
(() => {
  let cleanup, activeOverlay;
  function init() {
    const reopen = activeOverlay?.getAttribute('aria-hidden') === 'false';
    cleanup?.();
    const controller = new AbortController();
    const signal = controller.signal;
    const overlay = document.getElementById('nnyCartDrawerOverlay');
    if (!overlay) return;
    activeOverlay = overlay;
    const closeBtn = document.getElementById('nnyDrawerClose');

    const cartRoute = overlay?.dataset.cartUrl || '/cart';
    const status = document.getElementById('nnyDrawerStatus');
    const checkout = document.getElementById('nnySubmitCheckoutBtn');
    let returnFocus = null;
    let previousOverflow = '';
    let closeTimer;
    let cartBusy = false;
    cleanup = () => {
      controller.abort();
      clearTimeout(closeTimer);
      if (overlay.getAttribute('aria-hidden') === 'false') document.body.style.overflow = previousOverflow;
    };
    const setStatus = text => { if (status) { status.textContent = text; status.hidden = !text; } };
    const setBusy = busy => {
      cartBusy = busy;
      if (checkout) checkout.disabled = busy;
      overlay?.setAttribute('aria-busy', String(busy));
      overlay?.querySelectorAll('.nny-qty-btn, .nny-item-remove-btn').forEach(button => button.disabled = busy);
    };
    const requestCart = async (url, options = {}) => {
      const response = await fetch(url, {credentials:'same-origin', ...options, signal});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your bag. Please try again.');
      return data;
    };
    window.nnyOpenCartDrawer = function(trigger) {
      if (!overlay) return;
      clearTimeout(closeTimer);
      if (overlay.getAttribute('aria-hidden') !== 'false') {
        returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
        previousOverflow = document.body.style.overflow;
      }
      overlay.style.display = 'block';
      setTimeout(() => overlay.classList.add('is-visible'), 10);
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeBtn?.focus({preventScroll:true});
      return window.nnyRefreshCart().then(() => true).catch(() => false);
    };

    window.nnyCloseCartDrawer = function() {
      if (!overlay) return;
      overlay.classList.remove('is-visible');
      closeTimer = setTimeout(() => {
        overlay.style.display = 'none';
        document.body.style.overflow = previousOverflow;
        if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
      }, 300);
      overlay.setAttribute('aria-hidden', 'true');
    };

    if (closeBtn) closeBtn.addEventListener('click', window.nnyCloseCartDrawer, {signal});

    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) window.nnyCloseCartDrawer();
      }, {signal});
    }

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && overlay?.getAttribute('aria-hidden') === 'false') {
        const focusable = [...overlay.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el => el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
      }
      if (e.key === 'Escape' && overlay && overlay.classList.contains('is-visible')) {
        window.nnyCloseCartDrawer();
      }
    }, {signal});

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('#nnyCartTrigger, #cart-drawer-trigger-btn, a[href="/cart"], .nny-dock-item[href*="/cart"]');
      if (trigger) {
        e.preventDefault();
        window.nnyOpenCartDrawer();
      }
    }, {signal});

    window.nnyRefreshCart = async function() {
      setBusy(true);
      setStatus('Updating your bag…');
      try {
        const cart = await requestCart(`${cartRoute}.js`);
        nnyRenderCartDOM(cart);
        setStatus('');
        return cart;
      } catch (error) {
        setStatus('Your bag could not refresh. Close and reopen it to try again.');
        throw error;
      } finally { setBusy(false); }
    };

    window.nnyUpdateCartQuantity = async function(lineKey, newQty) {
      if (cartBusy) return;
      setBusy(true);
      setStatus('Updating your bag…');
      try {
        const cart = await requestCart(`${cartRoute}/change.js`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:lineKey,quantity:newQty})
        });
        nnyRenderCartDOM(cart);
        setStatus('');
      } catch (error) { setStatus(error.message); }
      finally { setBusy(false); }
    };

    function escapeCartHTML(value) {
      return String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }

    function nnyRenderCartDOM(cart, broadcast = true) {
      if (broadcast) document.dispatchEvent(new CustomEvent('nny:cart-updated', { detail: { source: 'drawer', cart } }));
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:cart.currency || 'USD'}).format(amount / 100);
      const savings = document.getElementById('nnySavingsVal');
      if (savings) {
        savings.textContent = `-${money(cart.total_discount || 0)}`;
        savings.closest('.nny-row-savings').hidden = !cart.total_discount;
      }
      document.querySelectorAll('#nnyCartCount, #nnyBottomCartBadge, #nnyBottomCartCount, #nnyDrawerItemCount').forEach(el => {
        if (el) el.textContent = cart.item_count;
      });

      const list = document.getElementById('nnyDrawerItemsList');
      const summaryBox = document.getElementById('nnyDrawerSummaryBox');
      const actions = document.getElementById('nnyDrawerActions');
      if (actions) actions.style.display = cart.item_count ? 'block' : 'none';

      if (cart.item_count === 0) {
        if (list) {
          list.innerHTML = `
            <div class="nny-drawer-empty font-mono">
              <p>YOUR GROOMING ARSENAL IS CURRENTLY EMPTY.</p>
              <a href="/collections/all" class="nny-empty-shop-btn font-display font-black">EXPLORE NYC FORMULAS</a>
            </div>
          `;
        }
        if (summaryBox) summaryBox.style.display = 'none';
        return;
      }

      if (summaryBox) summaryBox.style.display = 'block';

      if (list) {
        list.innerHTML = cart.items.map((item, idx) => {
          const itemPriceFormatted = money(item.final_line_price);
          const skuCode = escapeCartHTML(item.sku || `0${idx + 1}`);
          const itemUrl = escapeCartHTML(item.url);
          const planName = escapeCartHTML(item.selling_plan_allocation?.selling_plan?.name || 'One-Time Order');

          return `
            <div class="nny-cart-item" data-line-key="${item.key}">
              <a href="${itemUrl}" aria-label="${escapeCartHTML(item.product_title)}">${item.image ? `<img src="${escapeCartHTML(item.image)}" alt="${escapeCartHTML(item.title)}" class="nny-cart-item__img">` : ''}</a>
              <div class="nny-cart-item__content">
                <div class="nny-cart-item__header">
                  <div>
                    <span class="nny-cart-item__sku font-mono">NYC-${skuCode}</span>
                    <h3 class="nny-cart-item__title font-display"><a href="${itemUrl}">${escapeCartHTML(item.product_title)}</a></h3>
                    ${item.variant_title ? `<span class="nny-cart-item__variant font-mono">${escapeCartHTML(item.variant_title)}</span>` : ''}
                  </div>
                  <button type="button" class="nny-item-remove-btn" onclick="nnyUpdateCartQuantity('${item.key}', 0)" aria-label="Remover">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#71717a" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                  </button>
                </div>

                <div class="nny-cart-item__order-type font-mono">
                  <span>${planName}</span>
                </div>

                <div class="nny-cart-item__footer font-mono">
                  <div class="nny-qty-selector">
                    <button type="button" class="nny-qty-btn" onclick="nnyUpdateCartQuantity('${item.key}', ${item.quantity - 1})">-</button>
                    <span class="nny-qty-value">${item.quantity}</span>
                    <button type="button" class="nny-qty-btn" onclick="nnyUpdateCartQuantity('${item.key}', ${item.quantity + 1})">+</button>
                  </div>
                  <span class="nny-item-final-price">${itemPriceFormatted}</span>
                </div>
              </div>
            </div>
          `;
        }).join('');
      }

      const totalPrice = cart.total_price / 100;
      const formattedTotal = money(cart.total_price);

      const subtotalEl = document.getElementById('nnySubtotalVal');
      const grandTotalEl = document.getElementById('nnyGrandTotalVal');
      const btnPriceEl = document.getElementById('nnyBtnCheckoutPrice');
      const rewards = overlay.querySelector('[data-nny-rewards]');
      const creditsEl = rewards?.querySelector('[data-nny-points]');

      if (subtotalEl) subtotalEl.textContent = money(cart.original_total_price ?? cart.total_price);
      if (grandTotalEl) grandTotalEl.textContent = formattedTotal;
      if (btnPriceEl) btnPriceEl.textContent = formattedTotal;
      if (creditsEl) {
        const rate = Number(rewards.dataset.pointsRate || 10);
        const points = Math.floor(cart.total_price * rate / 100);
        creditsEl.textContent = '+' + new Intl.NumberFormat(document.documentElement.lang || 'en-US').format(points);
      }

      // LÓGICA DO FRETE GRÁTIS DINÂMICO
      const isAlwaysFree = overlay.dataset.alwaysFree === 'true';
      const threshold = parseFloat(overlay.dataset.threshold || 50);
      const successText = overlay.dataset.successText;
      const progressTemplate = overlay.dataset.progressText;

      const statusText = document.getElementById('nnyShippingStatusText');
      const percentText = document.getElementById('nnyShippingPercent');
      const barFill = document.getElementById('nnyShippingBarFill');

      if (isAlwaysFree || totalPrice >= threshold || threshold === 0) {
        if (statusText) statusText.textContent = successText;
        if (percentText) percentText.textContent = '100%';
        if (barFill) barFill.style.width = '100%';
      } else {
        const remaining = (threshold - totalPrice).toFixed(2);
        const percent = Math.min(100, Math.max(0, Math.round((totalPrice / threshold) * 100)));
        if (statusText) statusText.textContent = progressTemplate.replace('[amount]', `$${remaining}`);
        if (percentText) percentText.textContent = `${percent}%`;
        if (barFill) barFill.style.width = `${percent}%`;
      }
    }

    document.addEventListener('nny:cart-updated', event => {
      if (['page', 'box', 'quiz'].includes(event.detail?.source) && event.detail.cart) nnyRenderCartDOM(event.detail.cart, false);
    }, { signal });

    window.nnyQuickAdd = function(variantId) {
      if (!variantId) return;
      fetch(`${cartRoute}/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        window.nnyOpenCartDrawer();
      })
      .catch(err => console.error('Erro ao adicionar produto:', err));
    };
    if (reopen) window.nnyOpenCartDrawer();
  }
  init();
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('#nnyCartDrawerOverlay')) init();
  });
  document.addEventListener('shopify:section:select', event => {
    if (event.target.querySelector('#nnyCartDrawerOverlay')) window.nnyOpenCartDrawer();
  });
  document.addEventListener('shopify:section:deselect', event => {
    if (event.target.querySelector('#nnyCartDrawerOverlay')) window.nnyCloseCartDrawer();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('#nnyCartDrawerOverlay')) cleanup?.();
  });
})();
